<div class="absolute bottom-0
z-10 w-full py-3 bg-white/30 dark:bg-gray-900/30 backdrop-blur-sm border-t border-white/20 dark:border-gray-700/30 flex justify-center items-center text-xs md:text-sm text-gray-500 dark:text-gray-400">
  <div>
    <span>&copy; {{ currentYear }} Government ICT Services | GISP Version 3.0.0 </span>
  </div>
</div>
